import { METRICS_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const metricsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getServerHealth: builder.query({
            query: (hostname) => ({
                url: hostname 
                    ? `${METRICS_URL}/servers/${hostname}/health`
                    : `${METRICS_URL}/servers/health`,
            }),
            keepUnusedDataFor: 5,
        }),
        getEntraSignins: builder.query({
            query: () => ({
                url: `${METRICS_URL}/entra-signins`,
            }),
            keepUnusedDataFor: 5,
        }),
        getNetworkEvents: builder.query({
            query: () => ({
                url: `${METRICS_URL}/network-events`,
            }),
            keepUnusedDataFor: 5,
        }),
    })
});

export const { useGetServerHealthQuery, useGetEntraSigninsQuery, useGetNetworkEventsQuery } = metricsApiSlice;
